module.exports = __webpack_public_path__ + "img/clothing68.5ba9fdae.jpg";